<template>
  <div class="relative w-5 h-5">
    <transition-group>
      <svg v-if="expanded" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
      key="expanded-maximize-details-icon">
        <path d="M13.75 3.75V9.25C13.75 9.80228 14.1977 10.25 14.75 10.25H20.25M10.25 20.25V14.75C10.25 14.1977 9.80228 13.75 9.25 13.75H3.75M14.75 9.25L20.25 3.75M9.25 14.75L3.75 20.25" 
        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
      key="collapsed-maximize-details-icon">
        <path d="M8.25 3.75H5.75C4.64543 3.75 3.75 4.64543 3.75 5.75V8.25M15.75 3.75H18.25C19.3546 3.75 20.25 4.64543 20.25 5.75V8.25M20.25 15.75V18.25C20.25 19.3546 19.3546 20.25 18.25 20.25H15.75M8.25 20.25H5.75C4.64543 20.25 3.75 19.3546 3.75 18.25V15.75" 
        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'MaximizeDetailsIcon',
  props: {
    expanded: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.v-enter-active {
  transition: opacity 100ms ease-in-out;
}
.v-leave-active {
  transition: opacity 100ms ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
</style>